var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Container',[_c('SectionHeader',{attrs:{"title":"About us"}})],1),_vm._v(" "),_c('SocialLinks')],1)}
var staticRenderFns = []

export { render, staticRenderFns }